export default "__VITE_ASSET__Bv9LCo6L__"